import type { LatLng } from '~/_shared/types/latLng';

export const getDriveTimePathsPathId = (request: Readonly<{
  latLng: LatLng;
  hours: number;
  minutes: number;
}>): string => {
  return `${request.latLng.lat}-${request.latLng.lng}-${request.hours}-${request.minutes}`;
};
